import React from "react";
import { BILLING_PLANS, BILLING_RATES } from "./BillingPlansTabWithUsage";
import CameraUsageCyclePanel from "./CameraUsageCyclePanel";
import BillingPlansTabHierarchy from "./BillingPlansTabHierarchy";

// Keep these exports stable for existing tests/importers while the rendered
// billing experience now follows the Owner → Integrator → Admin hierarchy.
export { BILLING_PLANS, BILLING_RATES };

type Props = {
  camera: {
    cameraId?: string;
    planType?: string;
    planName?: string;
    [key: string]: any;
  };
  onUpdateCamera?: (camera: any) => void;
};

export default function BillingPlansTab({ camera, onUpdateCamera }: Props) {
  return (
    <div style={{ display: "grid", gap: 18 }}>
      <BillingPlansTabHierarchy
        camera={camera}
        onUpdateCamera={onUpdateCamera}
      />
      <CameraUsageCyclePanel camera={camera} />
    </div>
  );
}
